import { makeStyles } from '@material-ui/core'

export const scrollStyle = makeStyles((theme) => ({
  root: {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
}))
